<template>
  <div class="mobile-navigation d-md-none">
    <ul class="social-buttons">
      <li
        class="social-button"
        :class="socialItem.class"
        v-for="socialItem in social"
        :key="socialItem.class"
      >
        <a
          :href="socialItem.url"
          :target="socialItem.target"
          :title="socialItem.title"
        ></a>
      </li>
    </ul>
    <div class="user-mini-nav" v-if="user">
      <p>
        Welcome <span>{{ user.first_name }}</span>
      </p>
      <p>Credits: {{ user.credits }}</p>
      <!-- <a href="#">Profile</a> -->
      <p>
        <a href="" @click.prevent="redirectTo('/profile')"> My data </a>
      </p>
      <p>
        <a href="" @click.prevent="redirectTo('/subscription')">
          My subscription
        </a>
      </p>
      <a href="#" @click.prevent="logout">Logout</a>
    </div>
    <ul class="main-menu my-links">
      <li>
        <router-link
          :class="{ 'link-active': !my && !favourites }"
          to="/panel/diagrams"
          @click.native="clear"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 32 32"
          >
            <path
              d="M8 4v4H4V4zm2-2H2v8h8zm8 2v4h-4V4zm2-2h-8v8h8zm8 2v4h-4V4zm2-2h-8v8h8zM8 14v4H4v-4zm2-2H2v8h8zm8 2v4h-4v-4zm2-2h-8v8h8zm8 2v4h-4v-4zm2-2h-8v8h8zM8 24v4H4v-4zm2-2H2v8h8zm8 2v4h-4v-4zm2-2h-8v8h8zm8 2v4h-4v-4zm2-2h-8v8h8z"
              fill="currentColor"
            ></path>
          </svg>
          Slides library
        </router-link>
      </li>
      <li>
        <a
          href="#"
          :class="{ 'link-active': my }"
          @click.prevent="loadMySlides"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 32 32"
          >
            <path
              d="M20 21h-8a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-8-4v2h8v-2z"
              fill="currentColor"
            ></path>
            <path
              d="M28 4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v16a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-2 24H6V12h20zm2-18H4V6h24v4z"
              fill="currentColor"
            ></path>
          </svg>
          My slides
        </a>
      </li>
      <li>
        <a
          href="#"
          :class="{ 'link-active': favourites }"
          @click.prevent="loadFavourites"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 32 32"
          >
            <path
              d="M22.45 6a5.47 5.47 0 0 1 3.91 1.64a5.7 5.7 0 0 1 0 8L16 26.13L5.64 15.64a5.7 5.7 0 0 1 0-8a5.48 5.48 0 0 1 7.82 0l2.54 2.6l2.53-2.58A5.44 5.44 0 0 1 22.45 6m0-2a7.47 7.47 0 0 0-5.34 2.24L16 7.36l-1.11-1.12a7.49 7.49 0 0 0-10.68 0a7.72 7.72 0 0 0 0 10.82L16 29l11.79-11.94a7.72 7.72 0 0 0 0-10.82A7.49 7.49 0 0 0 22.45 4z"
              fill="currentColor"
            ></path>
          </svg>
          My wishlist
        </a>
      </li>
      <li>
        <a href="//infodiagram.com">Infodiagram.com</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'MobileMenu',
  props: ['menu', 'social', 'user'],
  computed: {
    ...mapState('filtering', ['my', 'favourites']),
    ...mapState(['mobileMenuActive'])
  },

  methods: {
    ...mapMutations('filtering', ['clearFiltering']),
    ...mapMutations(['toggleMobileMenu']),
    toggleSideMenu () {
      this.toggleMobileMenu()
      if (this.mobileMenuActive) {
        document.body.classList.add('mobile-nav-open')
      } else {
        document.body.classList.remove('mobile-nav-open')
      }
    },
    clear () {
      this.toggleSideMenu()
      this.clearFiltering()
    },
    loadFavourites () {
      this.toggleSideMenu()
      this.clearFiltering()
      this.$store.commit('filtering/toggleFavourites')
    },
    loadMySlides () {
      this.toggleSideMenu()
      this.clearFiltering()
      this.$store.commit('filtering/toggleMy')
    },
    redirectTo (route) {
      this.toggleSideMenu()
      this.$router.push(route)
    },
    async logout () {
      window.$chatwoot.reset()
      await this.$store.dispatch('auth/logout')
      await this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="scss">
@media screen and (max-width: 767px) {
  .main-header {
    padding: 0 14px;
  }
  .main-header,
  main {
    position: relative;
    left: 0;
    transition: left 0.25s ease-in-out;
  }

  .mobile-navigation {
    position: fixed;
    left: 0;
    top: 62px;
    bottom: 0;
    width: 100%;
    margin-left: -100%;
    display: block;
    transition: margin 0.25s ease-in-out;
    background: #fff;
    padding: 20px;

    .social-buttons {
      display: none;
      float: left;
      width: 100%;
      margin: 0;
      li {
        margin: 0px 5px;
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .user-mini-nav {
      color: var(--c-grey);
      float: left;
      width: 100%;
      margin: 20px 0px 10px;
      padding: 15px 0;
      border-top: 2px solid #fff;
      border-bottom: 2px solid #fff;
      p {
        margin-bottom: 10px;
        font-size: 20px;
        line-height: 27px;
      }
      a {
        display: inline-block;
        margin-right: 5px;
        font-size: 20px;
        line-height: 30px;
      }
      span {
        text-transform: capitalize;
      }
    }
    .main-menu {
      float: left;
      width: 100%;
      margin: 10px 0 20px;
      list-style-type: none;
      li {
        padding-bottom: 8px;
        margin-bottom: 8px;
        font-size: 14px;
        margin-left: 0;
        margin-right: 0;
        a {
          display: block;
          padding: 5px 0;
          border: none;
          color: #fff;
        }
      }
    }
  }

  .mobile-nav-open {
    overflow: hidden;
    .mobile-navigation {
      margin-left: 0;
      -moz-box-shadow: 6px 0px 8px 0px rgba(0, 0, 0, 0.2);
      -webkit-box-shadow: 6px 0px 8px 0px rgba(0, 0, 0, 0.2);
      box-shadow: 6px 0px 8px 0px rgba(0, 0, 0, 0.2);
    }
    .main-header,
    main {
      /* left: 240px; */
    }
    main {
      opacity: 0.4;
    }
  }
}
</style>
